import React from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

const ResponsiveExpander = props => {
  const { active } = props;

  const buttonMessage = active ? <span><LanguageStringResolver string="tableRow_ViewLess"/></span> : <span><LanguageStringResolver string="tableRow_ViewMore"/></span>;

  return (
    <button
      type="button"
      className="link"
    >
      <span>
        {buttonMessage}
      </span>
    </button>
  );
};


export default ResponsiveExpander;
